import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import AsyncSelect from "react-select/async";
import getAxiosInstance from "./../../Utils/axios";
import { DateTime } from "luxon";
import ShowScreens from "../../Components/ShowScreens";
import UpdateScheduleCampaign from "../../Components/UpdateScheduleCampaign";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export default function Campaign() {
  const [campaigns, setCampaign] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchFilter, setSearchFilter] = useState("");
  const [searchByType, setSearchByType] = useState("");
  const [limit, setLimit] = useState(20);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalCampaign, setTotalCampaign] = useState(0);
  console.log("55555555555555====>", campaigns);
  console.log("xxxx", campaigns);
  const getCampaign = () => {
    let jsonData = {
      limit: limit,
      page: pageNumber * limit,
      search: searchFilter,
      filter_by: searchByType,
    };
    // converting (json --> form-urlencoded)
    const data = Object.keys(jsonData)
      .map((key) => `${key}=${encodeURIComponent(jsonData[key])}`)
      .join("&");

    getAxiosInstance()
      .post("/admin/campaigns", data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        // Validating form
        setIsLoading(false);
        if (res.data.status === "success") {
          // console.log(res.data);
          setTotalCampaign(res.data.totalCount);
          setCampaign(res.data.result);
        } else if (res.data.status === "error")
          Toast.fire({ icon: "error", title: res.data.message });
        else Toast.fire({ icon: "error", title: "Cannot process request" });
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getCampaign();
  }, [limit, pageNumber, searchByType]);

  const changePage = ({ selected }) => setPageNumber(selected);

  const deleteCampaign = (id) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      html: "<h5>This campaign will be deleted?</h5>",
      showCancelButton: true,
      confirmButtonText: `Delete`,
      confirmButtonColor: "#D14343",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const params = { id: id };

        // converting (json --> form-urlencoded)
        const data = Object.keys(params)
          .map((key) => `${key}=${encodeURIComponent(params[key])}`)
          .join("&");

        getAxiosInstance()
          .post("/admin/delete-campaign", data, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          })
          .then((res) => {
            // Validating form
            setIsLoading(false);
            if (res.data.status === "success") {
              Toast.fire({
                icon: "success",
                title: "Successfully deleted campaign",
              });
              getCampaign();
            } else {
              console.log(res.data);
              Toast.fire({ icon: "error", title: "Unable to delete campaign" });
            }
          })
          .catch((err) => {
            Toast.fire({ icon: "error", title: "Unexpected Error" });
            setIsLoading(false);
            console.log(err);
          });
      }
    });
  };

  const doPlayPause = (id, status) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      html: "",
      showCancelButton: true,
      confirmButtonText: status ? " Pause" : "Play",
      confirmButtonColor: "#D14343",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const params = { id: id };

        // converting (json --> form-urlencoded)
        const data = Object.keys(params)
          .map((key) => `${key}=${encodeURIComponent(params[key])}`)
          .join("&");

        getAxiosInstance()
          .post("/admin/play-pause", data, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          })
          .then((res) => {
            // Validating form
            setIsLoading(false);
            if (res.data.status === "success") {
              Toast.fire({
                icon: "success",
                title: "Campaign status has been changed successfully.",
              });
              getCampaign();
            } else {
              console.log(res.data);
              Toast.fire({
                icon: "error",
                title: "Unable to change campaign status",
              });
            }
          })
          .catch((err) => {
            Toast.fire({ icon: "error", title: "Unexpected Error" });
            setIsLoading(false);
            console.log(err);
          });
      }
    });
  };

  const cancelCampaign = (id) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      html: "<h5>This campaign will be cancelled?</h5>",
      showCancelButton: true,
      confirmButtonText: `Cancel Campaign`,
      confirmButtonColor: "#D14343",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        const params = { id: id };

        // converting (json --> form-urlencoded)
        const data = Object.keys(params)
          .map((key) => `${key}=${encodeURIComponent(params[key])}`)
          .join("&");

        getAxiosInstance()
          .post("/admin/cancel-campaign", data, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          })
          .then((res) => {
            // Validating form
            setIsLoading(false);
            if (res.data.status === "success") {
              Toast.fire({
                icon: "success",
                title: "Successfully cancelled campaign",
              });
              getCampaign();
            } else {
              console.log(res.data);
              Toast.fire({ icon: "error", title: "Unable to cancel campaign" });
            }
          })
          .catch((err) => {
            Toast.fire({ icon: "error", title: "Unexpected Error" });
            setIsLoading(false);
            console.log(err);
          });
      }
    });
  };

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-sm-6">
                <h1 className="m-0">Campaign List</h1>
              </div>
              {/* <div className="col-sm-6">
                                <button type="button" className="btn btn-dark float-right" onClick={(e) => { window.location.href = "/broadcasting/campaign/add" }}>Add Campaign</button>
                            </div> */}
            </div>
            <div className="row justify-content-center mt-3">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    {/* <h3 className="card-title">Campaign List</h3> */}
                    <div class="card-tools row">
                      <div className="col-4">
                        <select
                          className="form-control"
                          value={searchByType}
                          onChange={(e) => setSearchByType(e.target.value)}
                          style={{ height: 31, padding: 0 }}
                        >
                          <option value="">All Campaign</option>
                          {/* <option value="past">Past</option>
                                                    <option value="present">Present</option>
                                                    <option value="future">Future</option> */}
                          <option value="cancel">Cancel</option>
                          <option value="live">Live</option>
                          <option value="schedule">Schedule</option>
                          <option value="complete">Complete</option>
                        </select>
                      </div>
                      <div className="col-8">
                        <div
                          className="input-group input-group-sm my-auto"
                          style={{ width: "100%" }}
                        >
                          <input
                            type="text"
                            name="table_search"
                            className="form-control float-right"
                            placeholder="Campaign"
                            value={searchFilter}
                            onChange={(e) => setSearchFilter(e.target.value)}
                          />
                          <div className="input-group-append">
                            <button
                              type="submit"
                              className="btn btn-default"
                              onClick={() => getCampaign()}
                            >
                              <i className="fas fa-search" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: 10 }}>SL No.</th>
                          <th>Campaign</th>
                          <th>Note</th>
                          <th>Media</th>
                          <th>Screen(s)</th>
                          <th>Created On</th>
                          <th>Scheduled Date</th>
                          <th>Status</th>
                          <th style={{ width: 120 }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={10}>Loading Campaign ...</td>
                          </tr>
                        )}
                        {!isLoading && totalCampaign === 0 && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={10}>No Campaign Found</td>
                          </tr>
                        )}

                        {campaigns?.map((campaign, i) => (
                          <tr key={i}>
                            <td>{i + 1}.</td>
                            <td>{campaign.name}</td>
                            <td>{campaign.notes}</td>
                            <td>
                              {campaign.media ? campaign.media.title : ""}
                            </td>
                            <td>
                              <ShowScreens screens={campaign.screens} />
                            </td>
                            <td>
                              {DateTime.fromISO(campaign.created_date).toFormat(
                                "dd LLL yyyy"
                              )}
                            </td>
                            {/* <td>
                                                            {DateTime.fromMillis(campaign.start_time).toFormat("dd LLL yyyy h:mm a")} - {DateTime.fromMillis(campaign.end_time).toFormat("dd LLL yyyy h:mm a")}
                                                        </td> */}

                            {campaign.scheduled && campaign.start_time ? (
                              <td>
                                {/* {DateTime.fromMillis(
                                  campaign.start_time
                                ).toFormat("dd LLL yyyy h:mm a")}{" "}
                                -{" "}
                                {DateTime.fromMillis(
                                  campaign.end_time
                                ).toFormat("dd LLL yyyy h:mm a")} */}

                                {`${DateTime.fromMillis(
                                  new Date(campaign.start_time).getTime()
                                ).toFormat(
                                  "dd MMM yyyy HH:mm"
                                )} - ${DateTime.fromMillis(
                                  new Date(campaign.end_time).getTime()
                                ).toFormat("dd MMM yyyy HH:mm")}`}
                              </td>
                            ) : (
                              <td></td>
                            )}
                            <td style={{ textTransform: "capitalize" }}>
                              {campaign.status}
                            </td>
                            <td>
                              <div style={{ display: "flex" }}>
                                {campaign.status === "live" && (
                                  <>
                                    {campaign.play ? (
                                      <button
                                        type="button"
                                        class="btn btn-secondary btn-sm ml-1"
                                        onClick={() =>
                                          doPlayPause(campaign._id, true)
                                        }
                                      >
                                        <i className="fas fa-pause"></i>
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        class="btn btn-success btn-sm ml-1"
                                        onClick={() =>
                                          doPlayPause(campaign._id, false)
                                        }
                                      >
                                        <i className="fas fa-play"></i>
                                      </button>
                                    )}
                                  </>
                                )}

                                {campaign.status === "schedule" && (
                                  <>
                                    <UpdateScheduleCampaign
                                      type={"update"}
                                      getAxiosInstance={getAxiosInstance}
                                      Toast={Toast}
                                      getCampaign={getCampaign}
                                      campaignUp={campaign}
                                    />
                                    <button
                                      type="button"
                                      class="btn btn-danger btn-sm ml-1"
                                      title="Cancel"
                                      onClick={() => cancelCampaign(campaign._id)}
                                    >
                                      <i className="fas fa-times"></i>
                                    </button>
                                  </>
                                )}
                                {/* <button type="button" class="btn btn-danger btn-sm ml-1" title="Delete" onClick={() => deleteCampaign(campaign._id)}>
                                                                    <i className="fas fa-trash"></i>
                                                                </button> */}
                                {campaign.status === "live" && (
                                  <button
                                    type="button"
                                    class="btn btn-danger btn-sm ml-1"
                                    title="Cancel"
                                    onClick={() => cancelCampaign(campaign._id)}
                                  >
                                    <i className="fas fa-times"></i>
                                  </button>
                                )}
                              </div>
                            </td>
                            {/* <td>{campaign._id}</td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer clearfix">
                    {totalCampaign > limit ? (
                      <ReactPaginate
                        previousLabel={"«"}
                        nextLabel={"»"}
                        pageCount={Math.ceil(totalCampaign / limit)}
                        onPageChange={changePage}
                        containerClassName={
                          "pagination pagination-sm m-0 float-right"
                        }
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        // previousClassName={"previous"}
                        previousLinkClassName={"page-link"}
                        // nextClassName={"next"}
                        nextLinkClassName={"page-link"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
